import React from "react";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import DuplicateFormDialog from "@icarius-pages/coursesMaster/components/duplicateFormDialog";
import { VisibilityIcon } from "@icarius-icons/index";
import TrainingPage from "./trainingPage";
import AssignmentPage from "./assignmentPage";
import CreateTrainingFormDialog from "./createTrainingFormDialog";
import UpdateTrainingFormDialog from "./updateTrainingFormDialog";
import useTrainingDefinition from "./useTrainingDefinition";
import TreeViewDialog from "@icarius-pages/coursesMaster/components/treeDialog";
import paths from "@icarius-router/paths";

const TrainingDefinition = ({ history }) => {

  const {
    ownColumnDef,
    trainingList,
    courseList,
    skillList,
    collaboratorsList,
    instructorList,
    userFieldsDefinition,
    trainingFormData,
    trainingTree,
    isLoading,
    state,
    handlers,
  } = useTrainingDefinition();

  const goBackButton = () => (
    <CustomIconButton
      title={getLocalizedString("goBack")}
      type={"goBack"}
      onClick={() => history.push(paths.trainingAndDevelopment)}
    />
  )

  const createButton = () => (
    <CustomIconButton
      title={getLocalizedString("createTraining")}
      onClick={() => handlers.handleOpenCreateTrainingForm()}
      type={"add"}
    />
  )

  const createSkillBasedCourseButton = () => (
    <CustomIconButton
      title={getLocalizedString("createSkillBasedTraining")}
      onClick={() => handlers.handleOpenCreateTrainingForm(true)}
      type={"groupAdd"} 
    />
  )

  const editButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("edit")}
      onClick={() => handlers.handleOpenUpdateTrainingForm(gridRef)}
      type={"edit"}
    />
  )

  const duplicateButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("duplicate")}
      onClick={() => handlers.handleOpenDuplicateTrainingForm(gridRef)}
      type={"duplicate"}
    />
  )

  const deleteButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("delete")}
      onClick={() => handlers.handleOpenDeleteTrainingDialog(gridRef)}
      type={"delete"}
    />
  )

  const assignButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("assignEmployeesToTraining")}
      onClick={() => handlers.handleOpenAssignPage(gridRef)}
      type={"addPerson"}
    />
  )

  const viewTreeButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("viewVisualizationTree")}
      onClick={() => handlers.handleOpenTreeDialog(gridRef)}
    >
      <VisibilityIcon />
    </CustomIconButton>
  )

  return (
    <>
      {
        !state.trainingPageIsOpen && !state.assignPageIsOpen &&
        <CommonPage
          isLoading={isLoading}
          title={getLocalizedString("training")}
          gridTitle={getLocalizedString("training")}
          customHeader={() => <Typography className="whiteText">{getLocalizedString("clicToOpenModulesAndActivities")}</Typography>}
          ownColumnDef={ownColumnDef}
          rowData={trainingList}
          handleRowClick={handlers.handleOpenTrainingPage}
          menuItems={[goBackButton, assignButton, createButton, createSkillBasedCourseButton, editButton, duplicateButton, deleteButton, viewTreeButton]}
          hasExpand
          hasHelp
        >
          {
            state.createTrainingFormIsOpen &&
            <CreateTrainingFormDialog
              open={state.createTrainingFormIsOpen}
              isSkillBased={state.isSkillBasedForm}
              skillList={skillList}
              courseList={courseList}
              collaboratorsList={collaboratorsList}
              submitCallback={handlers.handleCreateTraining}
              handleClose={handlers.handleCloseTrainingForm}
              isLoading={isLoading}
            />
          }
          {
            state.updateTrainingFormIsOpen &&
            <UpdateTrainingFormDialog
              open={state.updateTrainingFormIsOpen}
              readOnly={state.selectedTraining?.isInUse || false}
              data={trainingFormData}
              instructorList={instructorList}
              userFieldsDefinition={userFieldsDefinition}
              isLoading={isLoading}
              submitCallback={handlers.handleUpdateTraining}
              invalidFiles={state.trainingInvalidFiles}
              handleClearInvalidFiles={handlers.handleClearInvalidFiles}
              handleClose={handlers.handleCloseTrainingForm}
            />
          }
          {
            state.duplicateTrainingFormIsOpen &&
            <DuplicateFormDialog
              open={state.duplicateTrainingFormIsOpen}
              title={getLocalizedString("duplicateTraining", { trainingName: trainingFormData.name })}
              submitCallback={handlers.handleDuplicateTraining}
              handleClose={handlers.handleCloseDuplicateTrainingForm}
              isLoading={isLoading}
            />
          }
          {
            state.treeDialogIsOpen &&
            <TreeViewDialog
              open={state.treeDialogIsOpen}
              data={trainingTree}
              handleClose={handlers.handleCloseTreeDialog}
            />
          }
        </CommonPage>
      }
      {
        state.trainingPageIsOpen &&
        <TrainingPage
          training={state.selectedTraining}
          handleGoBack={handlers.handleCloseTrainingPage}
        />
      }
      {
        state.assignPageIsOpen &&
        <AssignmentPage
          training={state.selectedTraining}
          handleClose={handlers.handleCloseAssignPage}
        />
      }
    </>
  )
}

export default TrainingDefinition;